import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=23ea5864&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=ts&"
export * from "./Alert.vue?vue&type=script&lang=ts&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=23ea5864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea5864",
  null
  
)

export default component.exports